export const FAQ_DATA_RECEIVED = 'FAQ_DATA_RECEIVED'
export const FAQ_SEARCH_DATA_RECEIVED = 'FAQ_SEARCH_DATA_RECEIVED'